import { Phone } from "lucide-react";
import { COMPANY } from "@/data/siteContent";

export default function MobileStickyCTA() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-3 left-3 right-3 z-40"
    >
      <a
        href={COMPANY.phoneHref}
        className="flex items-center justify-center gap-2 w-full rounded-full bg-[#29ABE2] text-white font-semibold py-4 shadow-2xl shadow-black/20 active:scale-[0.99] transition-transform"
      >
        <Phone className="h-4 w-4" /> Call Now: {COMPANY.phone}
      </a>
    </div>
  );
}
